import type { EndpointMeta } from "@/apis/types";
import {
  createFetchAndHook,
  type FetchFactory,
  type HookFactory,
} from "@/shared/factories";
import { wsdotHighwayAlertsApiMeta } from "../apiMeta";
import {
  type AlertsByMapAreaInput,
  alertsByMapAreaInputSchema,
} from "./shared/highwayAlerts.input";
import { type Alert, alertSchema } from "./shared/highwayAlerts.output";

/**
 * Metadata for the fetchAlertsByMapArea endpoint
 */
export const alertsByMapAreaMeta = {
  functionName: "fetchAlertsByMapArea",
  endpoint: "/getAlertsByMapAreaAsJson?MapArea={MapArea}",
  inputSchema: alertsByMapAreaInputSchema,
  outputSchema: alertSchema.array(),
  sampleParams: { MapArea: "Seattle" },
  endpointDescription: "List highway alerts filtered by map area code.",
} satisfies EndpointMeta<AlertsByMapAreaInput, Alert[]>;

const { fetch, useHook } = createFetchAndHook<AlertsByMapAreaInput, Alert[]>({
  api: wsdotHighwayAlertsApiMeta,
  endpoint: alertsByMapAreaMeta,
  getCacheStrategy: () =>
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    require("./shared/highwayAlerts.endpoints").highwayAlertsGroup
      .cacheStrategy,
});

/**
 * Fetch function for retrieving highway alerts filtered by map area code
 */
export const fetchAlertsByMapArea: FetchFactory<AlertsByMapAreaInput, Alert[]> =
  fetch;

/**
 * React Query hook for retrieving highway alerts filtered by map area code
 */
export const useAlertsByMapArea: HookFactory<AlertsByMapAreaInput, Alert[]> =
  useHook;
